import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import flowRight from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { actions as reduxActions } from './reducers';
import getIdFromUrl from '../../utils/getIdfromUrl';
import NumbersRangesTable from './components/NumbersRangesTable';
import NumbersRangesTableBE from './components/NumberRangeTableBE';
import NumberRangeMultiedit from '../../modals/numberRangeMultiedit/NumberRangeMultiedit';
import { isDefined } from '../../utils/isDefined';
import getCustomJobs from '../../utils/getCustomJobs';
import TableSwitch from './components/TableSwitch';
import ConnectRangesTable from './components/ConnectRangesTable';
import withUserCheck from '../../utils/withUserCheck';
import MoveNumberRange from '../../modals/moveNumberRange/MoveNumberRange';
import SplitNumberRange from '../../modals/splitNumberRange/SplitNumberRange';

const ExternalNumber = ({
  location,
  resetExternalNoRanges,
  isConnectRangesTable,
  isPartnerOrDstnyAdmin,
  connectClientId
}) => {
  const client = useMemo(() => getIdFromUrl(location), [location]);

  useEffect(() => {
    (async () => {
      await getCustomJobs();
    })();

    return resetExternalNoRanges;

    // eslint-disable-next-line
  }, [client]);

  return (
    <>
      {isDefined(client) ? (
        <>
          {isPartnerOrDstnyAdmin && isDefined(connectClientId) && (
            <TableSwitch />
          )}
          {!isConnectRangesTable ? (
            <NumbersRangesTable client={client} />
          ) : (
            <ConnectRangesTable />
          )}
        </>
      ) : (
        <NumbersRangesTableBE client={client} />
      )}
      <NumberRangeMultiedit />
      <MoveNumberRange />
      <SplitNumberRange />
    </>
  );
};

const mapStatesToProps = ({ externalNoRanges, selectClient }) => {
  return {
    isConnectRangesTable: externalNoRanges.isConnectRangesTable,
    connectClientId: selectClient.selectedClient.connect30_domain
  };
};

const mapDispatchToProps = {
  resetExternalNoRanges: reduxActions.resetExternalNoRanges
};

export default flowRight(
  withRouter,
  withUserCheck,
  connect(mapStatesToProps, mapDispatchToProps)
)(ExternalNumber);
